<script setup>
  import { computed } from "vue";

  const props = defineProps({
    show: {
      type: Boolean,
      required: true,
    },
    cancelButtonText: {
      type: String,
      default: "취소",
    },
    confirmButtonText: {
      type: String,
      default: "확인",
    },
    size: {
      type: String,
      default: "xs",
    },
    keepOpenModal: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: true,
    },
  });

  const emits = defineEmits(["update:show", "submit", "cancel"]);

  const localShow = computed({
    get: () => props.show,
    set: (val) => emits("update:show", val),
  });

  const closeModal = () => {
    emits("update:show", false);
  };

  const cancelModal = () => {
    closeModal();
    emits("cancel");
  };

  const submitModal = () => {
    closeModal();
    emits("submit");
  };
</script>

<template>
  <ui-modal :closable="closable" :maskClosable="keepOpenModal" v-model:show="localShow" :size="size">
    <template #body>
      <slot />
    </template>
    <template #footer>
      <div class="btn-area justify-end">
        <n-button @click="cancelModal">{{ cancelButtonText }}</n-button>
        <n-button type="primary" @click="submitModal">
          {{ confirmButtonText }}
        </n-button>
      </div>
    </template>
  </ui-modal>
</template>
